import angular from 'angular';

import './force-change.styles.scss';

import Routes from './force-change.routes';
import ForcePasswordChangeController from './force-change.controller';

export default angular.module('autoboard.forcePasswordChange', [])
  .config(Routes)
  .controller('ForcePasswordChangeController', ForcePasswordChangeController)
  .name;
